import moment from 'moment'

// 这里存放所有公共方法的类
const toolRex = {
  // SYS_TYPE系统类型: 0传媒内控ampm;1 标识icpm
  SYS_TYPE: 1,
  IS_ENABLE: 0,
  MAX_AREA: 999999999,
  // 显示外协 0不显示1显示
  IS_SHOW_OUTSOURCE: 1,
  // 预算默认费用项
  BUGET_EXPENSE_DEFALUT: ['采购总预算', '人工总预算', '设备租赁预算', '分包总预算', '管理费总预算'],
  // 校验是5位数字的正则表达式
  numberNineRes5: /^[0-9]{0,5}$/,
  // 校验是9位数字的正则表达式
  numberNineRes: /^[0-9]{0,9}$/,
  // 校验是10位数字的正则表达式
  numberRes: /^[0-9]{0,10}$/,
  // 校验是32位数字的正则表达式
  numberOneToNineRes: /^[1-9]{1}([0-9]{0,31})$/,
  // 校验数字(小数点后两位)
  numberToFix2Res: /^[0-9]{1,8}(.[0-9]{0,2})?$/,
  fuNumberToFix2Res: /^(-)?[0-9]{1,8}(.[0-9]{0,2})?$/,
  numberToFix2ResNew: /^\d{1,8}(\.\d{0,2})?$/,
  numberToFix2Num: /^\d{1,7}(\.\d{0,2})?$/, // 数量前七后二
  numberToFix2ResStr: '请输输入99999999以内的数',
  numberToFix2ResMuli: /^(-)?[0-9]{1,8}(.[0-9]{0,2})?$/,
  // 校验数字(小数点后三位)
  numberToFix3Res: /^[0-9]{1,8}(.[0-9]{0,3})?$/,
  // 校验数字(小数点后四位)
  numberToFix4Res: /^[0-9]{1,8}(.[0-9]{0,4})?$/,
  // 校验数字(小数点前5位后三位)
  number5ToFix3Res: /^[0-9]{1,5}(.[0-9]{0,3})?$/,
  numberToFix1Res: /^[0-9]{1,8}(.[0-9]{0,1})?$/,
  // 仓库几级分仓
  stockGrade: 3,
  // 材料类型分级
  materialTypeGrade: 2,
  // 供应商分类分级
  supplierTypeGrade: 2,
  // 校验 汉字、字母、数字组合 最多输入20个字符
  textRex: function (start, end, haveSymbol) {
    start = start == null ? 20 : start
    if (end) {
      end = end - 1
    } else {
      start = start - 1
    }
    let spec = ''
    // if (haveSymbol != null && haveSymbol == 1) {
    spec = ' \\_\\-\\,\\，\\[\\]\\{\\}\\【\\】\\。\\、\\+\\?\\？\\<\\>\\《\\》\\=\\.\\;\\；\\/\\（\\）\\(\\)\\：\\~'
    spec += '\\~\\`\\·\\!\\！\\@\\#\\￥\\$\\%\\……\\^\\&\\*\\m³\\\n\\\r\\\t'
    // }
    return new RegExp('^\\S{1}[A-Z a-z 0-9 \\u4e00-\\u9fa5' + spec + ']{' + toolRex.getNumRange(start, end) + '}$')
  },
  textRexStr: function (start, end, haveSymbol) {
    start = start == null ? 20 : start
    let spec = ''
    if (haveSymbol != null && haveSymbol == 1) {
      spec = '.基础符号'
    }
    return '请输入汉字.字母.数字' + spec + '组合,' + toolRex.getNumStr(start, end) + '个字'
  },
  // 校验 汉字、字母、数字组合 最多输入20个字符
  textCodeRex: function (start, end, haveSymbol) {
    start = start == null ? 20 : start
    if (end) {
      end = end - 1
    } else {
      start = start - 1
    }
    let spec = ''
    // if (haveSymbol != null && haveSymbol == 1) {
    spec = ' \\_\\-\\,\\，\\[\\]\\{\\}\\【\\】\\。\\、\\+\\?\\？\\<\\>\\《\\》\\=\\.\\;\\；\\/\\（\\）\\：\\~'
    spec += '\\~\\`\\·\\!\\！\\@\\#\\￥\\$\\%\\……\\^\\&\\*\\m³'
    // }
    return new RegExp('^\\S{1}[A-Z a-z 0-9' + spec + ']{' + toolRex.getNumRange(start, end) + '}$')
  },
  textCodeRexStr: function (start, end, haveSymbol) {
    start = start == null ? 20 : start
    let spec = ''
    if (haveSymbol != null && haveSymbol == 1) {
      spec = '.基础符号'
    }
    return '请输入字母.数字' + spec + '组合,' + toolRex.getNumStr(start, end) + '个字'
  },
  // 校验字母、数字组合 最多输入10个字符
  codeRex: function (start, end) {
    start = start == null ? 10 : start
    return new RegExp('^[A-Za-z0-9]{' + toolRex.getNumRange(start, end) + '}$')
  },
  codeRexStr: function (start, end) {
    start = start == null ? 10 : start
    return '请输入字母.数字组合,' + toolRex.getNumStr(start, end) + '个字符'
  },
  // 校验字母、数字、下划线 组合 最多输入50个字符
  codeAndlineRex: function (start, end) {
    start = start == null ? 50 : start
    return new RegExp('^[A-Za-z0-9_]{' + toolRex.getNumRange(start, end) + '}$')
  },
  codeAndlineRexStr: function (start, end) {
    start = start == null ? 50 : start
    return '请输入字母.数字.下划线组合,' + toolRex.getNumStr(start, end) + '个字符'
  },
  // 校验字母、数字、- . 组合 最多输入50个字符
  codeAndlineAndpointRex: function (start, end) {
    start = start == null ? 50 : start
    return new RegExp('^[A-Za-z0-9-.]{' + toolRex.getNumRange(start, end) + '}$')
  },
  codeAndlineAndpointRexStr: function (start, end) {
    start = start == null ? 50 : start
    return '请输入字母.数字.-或.组合,' + toolRex.getNumStr(start, end) + '个字符'
  },
  // 校验正确的座机号或手机号   最多输入13个字符
  telAndPhoneRex: function (start, end) {
    start = start == null ? 13 : start
    // 简化成13位数字可加-   return new RegExp('^((0[0-9]{2,3}-{0,1}[0-9]{7,8})|(1[23456789][0-9]{9})|((400)-([0-9]3})-([0-9]{4})(.)([0-9]{1,4}))|((400)-([0-9]{3})-([0-9]{4}))){' + toolRex.getNumRange(start, end) + '}$')
    return new RegExp('^[0-9 \\-]{' + toolRex.getNumRange(start, end) + '}$')
  },
  telAndPhoneRexStr: function (start, end) {
    start = start == null ? 13 : start
    return '请输入正确的电话,' + toolRex.getNumStr(start, end) + '个字符'
  },
  // 校验正确的邮箱地址   最多输入100个字符
  emailRex: function (start, end) {
    start = start == null ? 100 : start
    return new RegExp('^[[A-Za-z0-9_]+@[a-z0-9]+.[a-z]{2,4}]{' + toolRex.getNumRange(start, end) + '}$')
  },
  emailRexStr: function (start, end) {
    start = start == null ? 100 : start
    return '请输入正确的邮箱,' + toolRex.getNumStr(start, end) + '个字符'
  },
  // 校验手机号
  mobileRex: /^1[3456789]\d{9}$/,
  mobileRexStr: '请输入正确的手机号',
  // 用户登录账号校验正则
  userNameRex: /^[A-Za-z0-9]{5,20}$/,
  userNameRexStr: '请输入汉字.字母.数字组合,最多输入5-20个字符',
  // 用户登录密码正则
  userPasswordRex: /^[A-Za-z0-9]{6,20}$/,
  userPasswordRexStr: '请输字母.数字组合,最多输入6-20个字符',
  // 详细地址校验,100字以内(含基础的符号)
  addressRex: function (start, end) {
    start = start == null ? 100 : start
    return toolRex.textRex(start, end, 1)
  },
  addressRexStr: function (start, end) {
    start = start == null ? 100 : start
    return toolRex.textRexStr(start, end, 1)
  },
  // 获取number字符串 如 2-10   最多10
  getNumStr: function (start, end) {
    let numStr = ''
    if (end == null) {
      numStr = '最多输入' + start
    } else {
      if (start == 0) {
        numStr = '最多输入' + end
      } else {
        numStr = start + '-' + end
      }
    }
    return numStr
  },
  // 获取number字符串 如 2,10
  getNumRange: function (start, end) {
    if (end == null) {
      end = start + ''
      start = 0
    }
    return start + ',' + end
  },
  /**
   * 将带时分秒的日期转为不带时分秒
   */
  getYYYYMMDD: function (str) {
    if (str == null || str == '') {
      return '--'
    }
    return str.substring(0, 10)
  },
  /**
   * 是否为空
   */
  ifIsNull: function (str) {
    if (str == null || str == '' || str == 'null' || str == undefined) {
      return true
    }
    return false
  },
  /**
   * 为空返回 --
   */
  ifNullToLine: function (str) {
    if (str == null || str == '' || str == 'null' || str == undefined) {
      return '--'
    }
    return str
  },
  /**
   * 为空返回 ''
   */
  ifNullToNull: function (str) {
    if (str == null || str == '' || str == 'null' || str == undefined) {
      return ''
    }
    return str
  },
  /**
   * 为空返回 0
   */
  ifNullToZero: function (str) {
    if (str == null || str == '' || str == 'null' || str == undefined) {
      return '0'
    }
    return str
  },
  /**
   * 为空返回 0.00
   */
  ifNullToZeroDecimal: function (str) {
    if (str == null || str == '' || str == 'null' || str == undefined) {
      return '0.00'
    }
    return str
  },
  // 百分比边界过滤
  propBorderCheck: function (num) {
    num = parseFloat(toolRex.ifNullToZero(num))
    if (num > 100) {
      num = 100
    } else if (num < 0) {
      num = 0
    }
    return num
  },
  // 根据年月获取该月多少天
  getDaysByYearMonth (year, month) {
    var temp = null
    month = parseInt(month, 10)
    temp = new Date(year, month, 0)
    return temp.getDate()
  },
  // 获得本月时间用的子方法
  getDateObj: function () {
    var obj = {}
    var date = new Date()
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? ('0' + m) : m
    var d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    var h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    var minute = date.getMinutes()
    var second = date.getSeconds()
    minute = minute < 10 ? ('0' + minute) : minute
    second = second < 10 ? ('0' + second) : second
    obj.year = y + ''
    obj.month = m + ''
    obj.day = d + ''
    obj.hour = h + ''
    obj.minute = minute + ''
    obj.second = second + ''
    return obj
  },
  // 获得当前时间字符串
  getDateObjStr (index) {
    var date = toolRex.getDateObj()
    if (index == 1) { // 年
      return date.year
    } else if (index == 2) { // 年月
      return date.year + '-' + date.month
    } else if (index == 3) { // 年月日
      return date.year + '-' + date.month + '-' + date.day
    } else if (index == 4) { // 年月日时
      return date.year + '-' + date.month + '-' + date.day + ' ' + date.hour
    } else if (index == 5) { // 年月日时分
      return date.year + '-' + date.month + '-' + date.day + ' ' + date.hour + ':' + date.minute
    } else { // 年月日时分秒
      return date.year + '-' + date.month + '-' + date.day + ' ' + date.hour + ':' + date.minute + ':' + date.second
    }
  },
  // 获得本月时间用的子方法
  getDateObjDate: function (dateStr) {
    var obj = {}
    var date = new Date(dateStr)
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? ('0' + m) : m
    var d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    var h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    var minute = date.getMinutes()
    var second = date.getSeconds()
    minute = minute < 10 ? ('0' + minute) : minute
    second = second < 10 ? ('0' + second) : second
    obj.year = y + ''
    obj.month = m + ''
    obj.day = d + ''
    obj.hour = h + ''
    obj.minute = minute + ''
    obj.second = second + ''
    return obj
  },
  // 转换百分数  如 0.12-> 12%
  getChangePercent (value) {
    return parseFloat((toolRex.ifNullToZeroDecimal(value) * 100).toFixed(2))
  },
  // 百分率获取  1 num1/num2
  getArithmeticPercent (num1, num2) {
    num1 = parseFloat(toolRex.ifNullToZeroDecimal(num1))
    num2 = parseFloat(toolRex.ifNullToZeroDecimal(num2))
    if (num2 == 0 && num1 != 0) {
      return '0'
    } else if (num2 == 0 && num1 == 0) {
      return '0'
    } else if (num1 == 0 && num2 != 0) {
      return '100'
    } else {
      var returnValue = parseFloat(((num1 / num2).toFixed(4) * 100).toFixed(2))
      return returnValue
      /* if (returnValue < 0) {
        return '0'
      } else {
        return returnValue
      } */
    }
  },
  // 百分率获取  2 num1-num2 / num1
  getArithmeticPercentTwo (num1, num2) {
    num1 = parseFloat(toolRex.ifNullToZeroDecimal(num1))
    num2 = parseFloat(toolRex.ifNullToZeroDecimal(num2))
    if (num1 == 0 && (num1 - num2) < 0) {
      return '-100'
    } else if (num1 == 0 && (num1 - num2) > 0) {
      return '100'
    } else if (num1 == 0 && (num1 - num2) == 0) {
      return '0'
    } else {
      var returnValue = parseFloat((((num1 - num2) / num1).toFixed(4) * 100).toFixed(2))
      return returnValue
    }
    /* if (num1 == 0 || (num1 - num2) < 0) {
      return '0'
    } else {
      var returnValue = parseFloat((((num1 - num2) / num1).toFixed(4) * 100).toFixed(2))
      if (returnValue < 0) {
        return '0'
      } else {
        return returnValue
      }
    } */
  },
  // 获得本月时间用的子方法
  dateFormatConversion: function (inputTime) {
    var date = new Date(inputTime)
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? ('0' + m) : m
    var d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    var h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    var minute = date.getMinutes()
    var second = date.getSeconds()
    minute = minute < 10 ? ('0' + minute) : minute
    second = second < 10 ? ('0' + second) : second
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
  },
  // 获得上月月时间用的子方法
  dateFormatConversion2: function (inputTime) {
    var date = new Date(inputTime)
    var y = date.getFullYear()
    var m = date.getMonth()
    m = m < 10 ? ('0' + m) : m
    var d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    var h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    var minute = date.getMinutes()
    var second = date.getSeconds()
    minute = minute < 10 ? ('0' + minute) : minute
    second = second < 10 ? ('0' + second) : second
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
  },
  dateToYYYYMMDD: function (inputTime) {
    var str = '--'
    if (inputTime != null && inputTime != '') {
      var date = new Date(inputTime)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      str = y + '-' + m + '-' + d
    }
    return str
  },
  // 获得本月时间  【本月1日到当天的时间】
  findMonth: function () {
    var currentYear = new Date().getFullYear()
    var currentMonth = new Date().getMonth()
    var monthStartDate = this.dateFormatConversion(new Date(currentYear, currentMonth, 1))
    // var monthEndDate = this.dateFormatConversion(new Date())
    // var obj = {}
    // obj.monthStartDate = monthStartDate
    // obj.monthEndDate = monthEndDate
    return monthStartDate
  },
  findlastMonth: function () {
    var currentYear = new Date().getFullYear()
    var currentMonth = new Date().getMonth()
    var monthStartDate = this.dateFormatConversion2(new Date(currentYear, currentMonth, 1))
    // var monthEndDate = this.dateFormatConversion(new Date())
    // var obj = {}
    // obj.monthStartDate = monthStartDate
    // obj.monthEndDate = monthEndDate
    return monthStartDate
  },
  // 获得本季度时间  【本季度1日到当天的时间】
  findQuarter: function () {
    var nowMonth = new Date().getMonth() // 当前月
    var nowYear = new Date().getFullYear() // 当前年
    // var nowDay = new Date().getDate()
    nowYear += (nowYear < 2000) ? 1900 : 0
    var quarterStartMonth = 0
    if (nowMonth < 3) {
      quarterStartMonth = 0
    }
    if (nowMonth > 2 && nowMonth < 6) {
      quarterStartMonth = 3
    }
    if (nowMonth > 5 && nowMonth < 9) {
      quarterStartMonth = 6
    }
    if (nowMonth > 8) {
      quarterStartMonth = 9
    }
    var quarterStartDate = new Date(nowYear, quarterStartMonth, 1)
    var myyear = quarterStartDate.getFullYear()
    var mymonth = quarterStartDate.getMonth() + 1
    var myweekday = quarterStartDate.getDate()
    if (mymonth < 10) {
      mymonth = '0' + mymonth
    }
    if (myweekday < 10) {
      myweekday = '0' + myweekday
    }
    quarterStartDate = myyear + '-' + mymonth + '-' + myweekday
    // var quarterEndDate = nowYear + '-' + ((nowMonth + 1) < 10 ? ('0' + (nowMonth + 1)) : (nowMonth + 1)) + '-' + (nowDay < 10 ? ('0' + nowDay) : nowDay)
    // var obj = {}
    // obj.quarterStartDate = quarterStartDate
    // obj.quarterEndDate = quarterEndDate
    return quarterStartDate
  },
  // 获得本年时间  【本年1日到当天的时间】
  findYear: function () {
    var year = new Date().getFullYear()
    // var month = new Date().getMonth() + 1
    // var nowDay = new Date().getDate()
    var yearStartDate = year + '-01' + '-01'
    // var yearEndDate = year + '-' + (month < 10 ? ('0' + month) : month) + '-' + (nowDay < 10 ? ('0' + nowDay) : nowDay)
    // var obj = {}
    // obj.yearStartDate = yearStartDate
    // obj.yearEndDate = yearEndDate
    return yearStartDate
  },
  getLastYear: function (index) {
    var year = new Date().getFullYear() - 1
    var yearDate = year + '-01' + '-01' // 年初 01-01
    if (index == 1) { // 年底 12-31
      yearDate = year + '-12' + '-31'
    }
    return yearDate
  },
  /**
   * 根据状态返回相应的时间
   * 1、一个月前
   * 2、三个月前
   * 3、半年前
   * 4、一年前
   * 5、当前时间
   */
  getlastmonth: function (state) {
    var myDate = new Date()
    var currentYear = myDate.getFullYear()
    var currentMonth = myDate.getMonth() + 1
    var currentDate = myDate.getDate()
    var lastDate
    // 一个月前的时间
    var prevCurrentYear = 0
    var prevCurrentMonth = 0
    var preDay = 0
    // 三个月前的时间
    var tmY = 0
    var tmM = 0
    var tmD = 0
    // 半年前的时间
    var halfY = 0
    var halfM = 0
    var halfD = 0
    // 一年前的时间
    var oneY = 0
    var oneM = 0
    var oneD = 0
    var daysInMonth = ['0', '31', '28', '31', '30', '31', '30', '31', '31', '30', '31', '30', '31']
    this.isYears(currentYear, daysInMonth)
    if (currentMonth == 0) {
      // 一月前的时间
      prevCurrentYear = currentYear - 1
      prevCurrentMonth = 12
      this.isYears(prevCurrentYear, daysInMonth)
      preDay = this.monthTime(prevCurrentMonth, currentDate, lastDate, daysInMonth)
      // 三个月前的时间
      tmY = currentYear - 1
      tmM = 10
      tmD = this.monthTime(tmM, currentDate, lastDate, daysInMonth)
      // 半年前的时间
      halfY = currentYear - 1
      halfM = 6
      halfD = this.monthTime(halfM, currentDate, lastDate, daysInMonth)
      // 一年前的时间
      oneY = currentYear - 1
      oneM = 0
      oneD = this.monthTime(oneM, currentDate, lastDate, daysInMonth)
    } else {
      // 一个月前的时间
      if (currentMonth == 1) {
        prevCurrentYear = currentYear - 1
      } else {
        prevCurrentYear = currentYear
      }
      prevCurrentMonth = this.isZero(currentMonth - 1)
      preDay = this.monthTime(prevCurrentMonth, currentDate, lastDate, daysInMonth)
      // 三个月前的时间
      if (currentMonth - 3 < 0) {
        tmY = currentYear - 1
        tmM = this.isZero(12 + (currentMonth - 3))
        this.isYears(tmY, daysInMonth)
        tmD = this.monthTime(tmM, currentDate, lastDate, daysInMonth)
      } else {
        tmY = currentYear
        tmM = this.isZero(currentMonth - 3)
        this.isZero(tmM)
        this.isYears(tmY, daysInMonth)
        tmD = this.monthTime(tmM, currentDate, lastDate, daysInMonth)
      }
      // 半年前的时间
      if (currentMonth - 6 < 0) {
        halfY = currentYear - 1
        halfM = this.isZero(12 + (currentMonth - 6))
        this.isZero(halfM)
        this.isYears(halfM, daysInMonth)
        halfD = this.monthTime(halfM, currentDate, lastDate, daysInMonth)
      } else {
        halfY = currentYear
        halfM = this.isZero(currentMonth - 6)
        this.isZero(halfM)
        this.isYears(halfM, daysInMonth)
        halfD = this.monthTime(halfM, currentDate, lastDate, daysInMonth)
      }
      // 一年前的时间
      oneY = currentYear - 1
      oneM = 12 + (currentMonth - 12)
      this.isYears(halfM, daysInMonth)
      oneD = this.monthTime(oneM, currentDate, lastDate, daysInMonth)
    }
    var now = currentYear + '-' + p(currentMonth) + '-' + p(currentDate)
    // 一个月前的时间
    var priceLastMonth = prevCurrentYear + '-' + p(prevCurrentMonth) + '-' + p(this.isoDate(prevCurrentYear, prevCurrentMonth, preDay))
    // 三个月前的时间
    var threeMonth = tmY + '-' + p(tmM) + '-' + p(this.isoDate(tmY, tmM, tmD))
    // 半年期的时间
    var halfTime = halfY + '-' + p(halfM) + '-' + p(this.isoDate(halfY, halfM, halfD))
    // 一年前的时间
    var oneTime = oneY + '-' + p(oneM) + '-' + p(this.isoDate(oneY, oneM, oneD))
    function p (s) {
      return s < 10 ? '0' + s : s
    }
    // 返回一月前时间
    if (state == 1) {
      return priceLastMonth
    }
    // 返回三月前时间
    if (state == 2) {
      return threeMonth
    }
    // 返回半年前时间
    if (state == 3) {
      return halfTime
    }
    // 返回一年前时间
    if (state == 4) {
      return oneTime
    }
    // 返回当前时间
    if (state == 5) {
      return now
    }
  },
  isYears: function (years, daysInMonth) {
    if (years % 4 == 0 && years % 100 != 0 || years % 400 == 0) {
      daysInMonth[2] = '29'
    }
  },
  monthTime: function (a, b, lastDate, daysInMonth) {
    if (daysInMonth[a] < b) {
      lastDate = daysInMonth[a]
    } else {
      lastDate = b
    }
    return lastDate
  },
  isZero: function (s) {
    if (s == 0) {
      return 12
    } else {
      return s
    }
  },
  getRangeDate: function (num) {
    // console.log(111111111111111111111)
    // num:0本月 1本季度 2本年度 3一个月内 4半年内 5一年内 6当前日和15天后 7 上月 8去年 9昨日 10 当前日
    var endDate = this.getlastmonth(5)
    var startDate
    if (num == 0) {
      startDate = this.findMonth()
      if (startDate != null && startDate.length > 10) {
        startDate = startDate.substring(0, 10)
      }
      endDate = this.getLastDateByType(0)
    }else if (num == 7) {
      startDate = this.findlastMonth()
      if (startDate != null && startDate.length > 10) {
        startDate = startDate.substring(0, 10)
      }
      endDate = this.getLastDateByType(4)
    } else if (num == 1) {
      startDate = this.findQuarter()
      endDate = this.getLastDateByType(1)
    } else if (num == 2) {
      startDate = this.findYear()
      endDate = this.getLastDateByType(2)
    } else if (num == 3) {
      startDate = this.getlastmonth(1)
    } else if (num == 4) {
      startDate = this.getlastmonth(3)
    } else if (num == 5) {
      startDate = this.getlastmonth(4)
    } else if (num == 6) {
      startDate = this.dateFormatConversion(new Date())
      if (startDate != null && startDate.length > 10) {
        startDate = startDate.substring(0, 10)
      }
      var afterDate15 = new Date()
      afterDate15.setDate(new Date().getDate() + 15) // 15天后的日期
      endDate = this.dateFormatConversion(afterDate15)
      if (endDate != null && endDate.length > 10) {
        endDate = endDate.substring(0, 10)
      }
    } else if (num == 8) { // 去年
      startDate = this.getLastYear(0)
      endDate = this.getLastYear(1)
    }else if (num == 9) { // 昨日
      var laseDate1 = new Date()
      laseDate1.setDate(new Date().getDate()-1) // 昨天的日期
      startDate = this.dateFormatConversion(laseDate1).substring(0, 10)
      endDate = startDate
    }else if (num == 10) { // 今日
      startDate = this.dateFormatConversion(new Date())
      startDate = startDate.substring(0, 10)
      endDate = this.dateFormatConversion(new Date())
      endDate = endDate.substring(0, 10)
    }
    var obj = {}
    obj.startDate = startDate
    obj.endDate = endDate
    // this.initGetRangeDateArr()
    return obj
  },
  getRangeDateJY: function (num) { // 积压统计专用
    var startDate = null
    var endDate = null
    if (num == 0) {
      endDate = this.getlastmonth(2)
    } else if (num == 1) {
      endDate = this.getlastmonth(3)
    } else if (num == 2) {
      endDate = this.getlastmonth(4)
    }
    var obj = {}
    obj.endDate = endDate
    obj.startDate = startDate
    return obj
  },
  // 昨天今天明天
  getRangeDateThreeDay: function (num) { // 积压统计专用
    var yesterday = new Date()
    var today = new Date()
    var tomorrow = new Date()
    yesterday = yesterday.setTime(yesterday.getTime() - 24 * 60 * 60 * 1000)
    tomorrow = tomorrow.setTime(tomorrow.getTime() + 24 * 60 * 60 * 1000)
    var obj = {}
    obj.yesterday = this.dateFormatConversion(yesterday)
    obj.today = this.dateFormatConversion(today)
    obj.tomorrow = this.dateFormatConversion(tomorrow)
    return obj
  },
  initGetRangeDateJYArr () {
    var list = []
    var obj = {}
    obj.startDate = null
    obj.endDate = this.getRangeDateJY(0).endDate
    list.push(obj)
    obj = {}
    obj.startDate = null
    obj.endDate = this.getRangeDateJY(1).endDate
    list.push(obj)
    obj = {}
    obj.startDate = null
    obj.endDate = this.getRangeDateJY(2).endDate
    list.push(obj)
    return list
  },
  getRangeDateHHmmss: function (num) {
    var timeObj = {}
    if (num == 6) {
      const startDate = this.dateFormatConversion(new Date())
      timeObj.startDate = startDate
      return timeObj
    }
    timeObj = JSON.parse(JSON.stringify(this.getRangeDate(num)))
    var startDate = timeObj.startDate
    if (startDate != null && startDate.length <= 10) {
      startDate = startDate.substring(0, 10) + ' 00:00:00'
    }
    var endDate = timeObj.endDate
    if (endDate != null && endDate.length <= 10) {
      endDate = endDate.substring(0, 10) + ' 23:59:59'
    }
    timeObj.startDate = startDate
    timeObj.endDate = endDate
    if (num == 6) {
      startDate = this.dateFormatConversion(new Date())
    }
    return timeObj
  },
  initGetRangeDateArr () {
    var list = []
    var obj = {}
    obj.startDate = this.getRangeDate(0).startDate
    obj.endDate = this.getRangeDate(0).endDate
    list.push(obj)
    obj = {}
    obj.startDate = this.getRangeDate(3).startDate
    obj.endDate = this.getRangeDate(3).endDate
    list.push(obj)
    obj = {}
    obj.startDate = this.getRangeDate(1).startDate
    obj.endDate = this.getRangeDate(1).endDate
    list.push(obj)
    obj = {}
    obj.startDate = this.getRangeDate(2).startDate
    obj.endDate = this.getRangeDate(2).endDate
    list.push(obj)
    obj = {}
    obj.startDate = this.getRangeDate(4).startDate
    obj.endDate = this.getRangeDate(4).endDate
    list.push(obj)
    obj = {}
    obj.startDate = this.getRangeDate(5).startDate
    obj.endDate = this.getRangeDate(5).endDate
    list.push(obj)
    return list
  },
  initGetRangeHHmmssDateArr () {
    var list = []
    var obj = {}
    obj.startDate = this.getRangeDateHHmmss(0).startDate
    obj.endDate = this.getRangeDateHHmmss(0).endDate
    list.push(obj)
    obj = {}
    obj.startDate = this.getRangeDateHHmmss(3).startDate
    obj.endDate = this.getRangeDateHHmmss(3).endDate
    list.push(obj)
    obj = {}
    obj.startDate = this.getRangeDateHHmmss(1).startDate
    obj.endDate = this.getRangeDateHHmmss(1).endDate
    list.push(obj)
    obj = {}
    obj.startDate = this.getRangeDateHHmmss(2).startDate
    obj.endDate = this.getRangeDateHHmmss(2).endDate
    list.push(obj)
    obj = {}
    obj.startDate = this.getRangeDateHHmmss(4).startDate
    obj.endDate = this.getRangeDateHHmmss(4).endDate
    list.push(obj)
    obj = {}
    obj.startDate = this.getRangeDateHHmmss(5).startDate
    obj.endDate = this.getRangeDateHHmmss(5).endDate
    list.push(obj)
    return list
  },
  getLastDateByType (type) {
    var nowDate = new Date()
    var currentYear = nowDate.getFullYear()
    var currentMonth = nowDate.getMonth()
    var endDate = new Date()
    if (type == 0) {
    } else if (type == 1) {
      if (currentMonth <= 2) {
        currentMonth = 2
      } else if (currentMonth <= 5) {
        currentMonth = 5
      } else if (currentMonth <= 8) {
        currentMonth = 8
      } else {
        currentMonth = 11
      }
    } else if (type == 4) {
      currentMonth = currentMonth-1
    }else {
      currentMonth = 11
    }
    endDate = new Date(currentYear, currentMonth + 1, 0)
    var lastYear = endDate.getFullYear()
    var lastMonth = endDate.getMonth() + 1
    var lastDate = endDate.getDate()
    return lastYear + '-' + (lastMonth < 10 ? '0' + lastMonth : lastMonth) + '-' + lastDate
  },
  isoDate: function (y, m, d) {
    var dd = d
    if (y % 4 == 0 && y % 100 != 0 || y % 400 == 0) {
      // console.log('闰年')
    } else {
      // console.log('平年')
      if ((m == '2' || m == '02') && d == '29') {
        dd = '28'
      }
    }
    return dd
  },
  // 生成32位随机数
  getNum: function () {
    var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
    var nums = ''
    for (var i = 0; i < 32; i++) {
      var id = parseInt(Math.random() * 61)
      nums += chars[id]
    }
    return nums
  },
  fnGetPkeyId (selectedRowKeys) {
    var ids = ''
    if (selectedRowKeys && selectedRowKeys.length > 0) {
      selectedRowKeys.forEach(id => {
        ids += id + ','
      })
    }
    return ids
  },
  fnGetRoleActionRuleNo (session, menuId, actionId) { // 判断用户操作权限
    const permissions = [...session.role.permissions] // 获取权限
    const onePermissions = permissions.filter(item => menuId === item.id)[0] // 获取唯一一条菜单权限
    if (onePermissions != null && onePermissions.roleActionRules != null && onePermissions.roleActionRules.length > 0) { //
      const roleActionRules = [...onePermissions.roleActionRules] // 获取菜单权限中的操作权限
      const oneRoleActionRules = roleActionRules.filter(item => actionId === item.actionId)[0] // 获取菜单权限中唯一一条操作权限
      if (oneRoleActionRules != null) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  },
  fnGetRoleActionRuleNoSupper (session, menuId, actionId) { // 判断用户操作权限
    const permissions = [...session.role.permissions] // 获取权限
    const onePermissions = permissions.filter(item => menuId === item.id)[0] // 获取唯一一条菜单权限
    if (onePermissions != null && onePermissions.roleActionRules != null && onePermissions.roleActionRules.length > 0) { //
      const roleActionRules = [...onePermissions.roleActionRules] // 获取菜单权限中的操作权限
      const oneRoleActionRules = roleActionRules.filter(item => actionId === item.actionId)[0] // 获取菜单权限中唯一一条操作权限
      if (oneRoleActionRules != null) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  },
  fnGetRoleActionRule (session, menuId, actionId) { // 判断用户操作权限
    if (session.role.isSupper == 1) { // 超级管理员
      return true
    } else { // 不是超级管理员
      const permissions = [...session.role.permissions] // 获取权限
      const onePermissions = permissions.filter(item => menuId === item.id)[0] // 获取唯一一条菜单权限
      if (onePermissions != null && onePermissions.roleActionRules != null && onePermissions.roleActionRules.length > 0) { //
        const roleActionRules = [...onePermissions.roleActionRules] // 获取菜单权限中的操作权限
        const oneRoleActionRules = roleActionRules.filter(item => actionId === item.actionId)[0] // 获取菜单权限中唯一一条操作权限
        if (oneRoleActionRules != null) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  fnGetRoleDataRule (session, menuId, dataId) { // 判断用户数据权限
    if (session.role.isSupper == 1) { // 超级管理员
      return true
    } else { // 不是超级管理员
      const permissions = [...session.role.permissions] // 获取权限
      const onePermissions = permissions.filter(item => menuId === item.id)[0] // 获取唯一一条菜单权限
      if (onePermissions != null && onePermissions.roleDataRules != null && onePermissions.roleDataRules.length > 0) { //
        const roleDataRules = [...onePermissions.roleDataRules] // 获取菜单权限中的数据权限
        const oneRoleDataRules = roleDataRules.filter(item => dataId === item.dataId)[0] // 获取菜单权限中唯一一条数据权限
        if (oneRoleDataRules != null) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  fnGetRoleMenuRule (session, menuId) { // 判断用户数据权限
    if (session.role.isSupper == 1) { // 超级管理员
      return true
    } else { // 不是超级管理员
      const permissions = [...session.role.permissions] // 获取权限
      const onePermissions = permissions.filter(item => menuId === item.id)[0] // 获取唯一一条菜单权限
      if (onePermissions != null) { //
        return true
      } else {
        return false
      }
    }
  },
  /**
   * 解决parseFloat丢失精度问题
   */
  fnFormatFloat (f, num) {
    // 返回的是10的digit次幂
    if (isNaN(f)) {
      return false
    }
    var m = Math.pow(10, num)
    // 四舍五入
    // return Math.round(f * m, 10) / m
    return Math.round(numberTool.numMulti(f, m), 10) / m
  },
  /**
   * 保留3位小数，如：2，会在2后面补上00.即2.00  3.145 = 3.15  3.144 = 3.14
   * 调用方式：toolRex.toDecimal(money, 2)
   */
  toDecimal (x, num) {
    var f = this.fnFormatFloat(x, num)
    if (isNaN(f)) {
      return false
    }
    var s = f.toString()
    var rs = s.indexOf('.')
    if (rs < 0) {
      rs = s.length
      s += '.'
    }
    while (s.length <= rs + num) {
      s += '0'
    }
    return s
  }
}

const msgTool = {
  successStr: '操作成功', // 成功提示
  selMaxLength: 30, // 查询输入框的最大输入
  messageInfo: function (pageObj, msgStr) {
    pageObj.$message.config({
      top: `105px`
    })
    pageObj.$message.info(msgStr, 3)
  },
  messageError: function (pageObj, msgStr) {
    pageObj.$message.config({
      top: `105px`
    })
    pageObj.$message.error(msgStr, 3)
  },
  messageWarning: function (pageObj, msgStr) {
    pageObj.$message.config({
      top: `105px`
    })
    pageObj.$message.warning(msgStr, 3)
  },
  success: function (pageObj, msgStr) {
    pageObj.$message.config({
      top: `105px`
    })
    if(toolRex.ifIsNull(msgStr)){
      msgStr = this.successStr
    }
    pageObj.$message.success(msgStr, 3)
  },
  info: function (pageObj, msgStr) {
    pageObj.$message.config({
      top: `105px`
    })
    pageObj.$message.info(msgStr, 3)
  },
  error: function (pageObj, msgStr) {
    pageObj.$message.config({
      top: `105px`
    })
    console.log('请求错误tools-msgTool-error', msgStr)
    let msg = ''
    if (msgStr.retMsg != null || msgStr.message != null) {
      msg = this.error2Str(msgStr)
    }
    pageObj.$message.error(msg, 3)
  },
  warn: function (pageObj, msgStr) {
    pageObj.$message.config({
      top: `105px`
    })
    pageObj.$message.warning(msgStr, 3)
  },
  error2Str: function (err) {
    let msg = '请求出现错误，请稍后再试'
    if (err.retMsg != null) {
      if (err.retMsgCode != null && err.retMsgCode == 'server') {
        msg = '请求出现错误，请稍后再试(' + err.retMsg + ')'
      } else {
        msg = err.retMsg
      }
    } else if (err.message != null) {
      msg = '请求出现错误，请稍后再试(' + err.message + ')'
    }
    return msg
  },
  phonePassword: function (tel) {
    if (tel != null) {
      var reg = /^(\d{3})\d{4}(\d{4})$/
      tel = tel.replace(reg, '$1****$2')
    }
    return tel
  },
  labelSpace: function (name, length) { // 空格补位符号
    let rtStr = name == null ? '' : name
    length = length == null ? 5 : length
    var size = length - name.length
    for (let index = 0; index <= size; index++) {
      rtStr = '　' + rtStr
    }
    return rtStr
  },
  isEmpty: function (str) { // 校验字符串是否为空
    if (str == null || str == '' || str == 'null' || str == undefined) {
      return true
    }
    return false
  }
}

const commonTool = {
  refreshAddFlg: true, // 是否刷新到第一页 true是，false否
  showBorderedFlg: false, // 是否显示表格边框 true是，false否
  showPaginationFlg: false, // 是否显示分页控件 true是，auto否 适用于s-table  值: true:一直显示分页控件 auto:数据条数超过一页才显示分页控件
  bugetCostName: '产品生产费', // 预算模板产品费名称
  // 弹出层关闭回调
  closePage: function (thiss, refresTable) {
    if (refresTable) {
      refresTable = false
    }
    thiss.$parent.refresTable(refresTable)
    thiss.$layer.closeAll('iframe') // 能全关，但找不到自己的位置
    commonTool.move()
  },
  // 弹出层关闭回调
  closeSinglePage: function (thiss, refresTable) {
    if (refresTable) {
      refresTable = false
    }
    thiss.$parent.refresTable(refresTable)
    thiss.colseLayUser()
    commonTool.move()
  },
  // 弹出层关闭回调没有刷新
  closeSinglePageNoRefres: function (thiss) {
    thiss.colseLayUser()
    commonTool.move()
  },
  // 弹出层关闭 只关闭不做其他操作
  closeOnlySinglePage: function (thiss) {
    thiss.colseLayUser()
  },
  // 弹出层关闭回调(右上角X)
  closeSinglePageRight: function (thiss, refresTable) {
    if (refresTable) {
      refresTable = false
    }
    if (typeof thiss.refresTable === 'function') {
      thiss.refresTable(refresTable)
    }
    // thiss.colseLayUser()
    commonTool.move()
  },
  // 清空选择同时刷新表格数据
  clearTableSelected: function (table) {
    table.refresh()
    setTimeout(function () {
      table.clearSelected()
    }, 800)
  },
  // 0绿1红
  formatColor (type) {
    if (type == '1') {
      return 'color:red'
    } else if (type == '0') {
      return 'color:green'
    }
  },
  // 0绿1土灰
  formatColorIsFast (type) {
    if (type == '1') {
      return 'color:#e0a901'
    } else if (type == '0') {
      return 'color:green'
    }
  },
  // 0红1绿
  formatColor2 (type) {
    if (type == '0') {
      return 'color:red'
    } else if (type == '1') {
      return 'color:green'
    }
  },
  formatColorPm (status) {
    if (status == 1) {
      return 'color:#3da1ff'
    } else if (status == 2) {
      return 'color:#ff8400'
    } else if (status == 3) {
      return 'color:#13c864'
    } else if (status == 4) {
      return 'color:#d165f0'
    } else if (status == 5) {
      return 'color:#ed2d2d'
    } else {
      return ''
    }
  },
  // 项目信息管理状态颜色切换
  formatColorPmProjectInfo (record) {
    if (record.status == 0) {
      return 'color:#e0a901'
    } else if (record.status == 1) {
      return 'color:#3da1ff'
    } else if (record.status == 2) {
      return 'color:#d165f0'
    } else if (record.status == 3) {
      return 'color:#88bb00'
    } else if (record.status == 4) {
      return 'color:#b5007f'
    } else if (record.status == 5) {
      return 'color:#5500DD'
    } else if (record.status == 6) {
      return 'color:#CC0000'
    } else if (record.status == 7) {
      return 'color:#ed2d2d'
    } else if (record.status == 8) {
      return 'color:#13c864'
    } else {
      return ''
    }
  },
  // 项目预算管理状态颜色切换
  formatColorPmProjectBuget (record) {
    if (record.mainState == 0) {
      return 'color:#e0a901'
    } else if (record.mainState == 1) {
      return 'color:#3da1ff'
    } else if (record.mainState == 2) {
      return 'color:#d165f0'
    } else if (record.mainState == 3) {
      if (record.projectProcessState != 2) {
        return 'color:#88bb00'
      } else {
        return 'color:#13c864'
      }
    } else if (record.mainState == 4) {
      return 'color:#b5007f'
    } else if (record.mainState == 5) {
      return 'color:#5500DD'
    } else if (record.mainState == 6) {
      return 'color:#ed2d2d'
    } else {
      return ''
    }
  },
  // 项目合同审批状态颜色切换
  formatColorMainState (status) {
    if (status == 1) {
      return 'color:#3da1ff'
    } else if (status == 2) {
      return 'color:#d165f0'
    } else if (status == 3) {
      return 'color:#88bb00'
    } else if (status == 4) {
      return 'color:#e0a901'
    } else if (status == 5) {
      return 'color:#13c864'
    } else if (status == 6) {
      return 'color:#5500DD'
    } else if (status == 7) {
      return 'color:#ed2d2d'
    } else {
      return ''
    }
  },
  // 项目进程管理状态颜色切换
  formatColorPmProjectProcess (status) {
    if (status == 1) {
      return 'color:#3da1ff'
    } else if (status == 2) {
      return 'color:#88bb00'
    } else if (status == 3) {
      return 'color:#13c864'
    } else if (status == 4) {
      return 'color:#d165f0'
    } else if (status == 5) {
      return 'color:#b5007f'
    } else if (status == 6) {
      return 'color:#5500DD'
    } else {
      return ''
    }
  },
  // 项目任务状态颜色切换
  formatColorPmProjectInfoTask (status) {
    if (status == 2) {
      return 'color:#88bb00'
    } else if (status == 3) {
      return 'color:#13c864'
    } else if (status == 5) {
      return 'color:#b5007f'
    } else if (status == 6) {
      return 'color:#005a71'
    } else {
      return ''
    }
  },
  // 财务管理状态颜色切换
  formatColorFm (status) {
    if (status == 0) {
      return 'color:#ff8400'
    } else if (status == 1) {
      return 'color:#15c25e'
    } else if (status == 2) {
      return 'color:#ed2d2d'
    } else {
      return ''
    }
  },
  // 财务回款管理颜色切换
  formatColorFmPayment (row) {
    if (row.backState === 0 && row.clearState === 0) {
      return 'color:#3da1ff'
    } else if (row.backState === 1 && row.clearState === 0) {
      return 'color:#ff8400'
    } else if (row.backState === 1 && row.clearState === 1) {
      return 'color:#15c25e'
    } else {
      return ''
    }
  },
  // 审批状态颜色切换
  formatColorFlowState (row) {
    if (row.flowState === 0) {
      return 'color:#ff8400'
    } else if (row.flowState === 1) {
      return 'color:#13c864'
    } else if (row.flowState === 2) {
      return 'color:#ed2d2d'
    } else {
      return ''
    }
  },
  // 供应商状态颜色切换
  formatColorPurSupplierInfo (row) {
    if (row.mainState == 0) {
      return 'color:#3da1ff'
    } else if (row.mainState == 1) {
      return 'color:#ff8400'
    } else if (row.mainState == 2) {
      return 'color:#13c864'
    } else if (row.mainState == 3) {
      return 'color:#ed2d2d'
    } else {
      return ''
    }
  },
  // 供应商采购订单颜色切换
  formatColorPurPurchaseOrder (row) {
    if (row.payState == 0) {
      return 'color:#3da1ff'
    } else if (row.payState == 1) {
      return 'color:#ff8400'
    } else if (row.payState == 2) {
      return 'color:#13c864'
    } else {
      return ''
    }
  },
  // 禁止滚动
  stopMove () {
    const m = function (e) { e.preventDefault() }
    // document.body.style.overflow = 'hidden'
    document.getElementById('mybody').style.overflow = 'hidden'
    document.addEventListener('touchmove', m, { passive: false }) // 禁止页面滑动
  },
  // 恢复滚动
  move () {
    var m = function (e) { e.preventDefault() }
    // document.body.style.overflow = '' // 出现滚动条
    document.getElementById('mybody').style.overflow = ''
    document.removeEventListener('touchmove', m, false)
  },
  // 文字换行样式
  textAlignLeft () {
    return 'left'
  },
  // 文字换行样式
  textAlignCenter () {
    return 'center'
  },
  textAlignRight () {
    return 'right'
  },
  breakStyle () {
    return 'word-break: break-all; word-wrap: break-word'
  },
  wordMin () {
    return '7%'
  },
  wordOpt () {
    return '8%'
  },
  wordName () {
    return '12%'
  },
  word4 () {
    return '9%'
  },
  word5 () {
    return '11%'
  },
  word6 () {
    return '12%'
  },
  fixedText2Money (param, property) {
    if (typeof (param) === 'object') {
      param[property] = param[property].replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
    } else {
      return param.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
    }
  },
  validateFields_fumoney (e) {
    var value = e.target.value.replace(/^((-)?\d*(?:\.\d{0,2})?).*$/g, '$1')
    e.target.value = value
    return value
  },
  validateFields_money (e) {
    var value = e.target.value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
    e.target.value = value
    return value
  },
  validateFields_money_limit (e) { // 文本框输入金额限制 小数点前八后二
    var value1 = e.target.value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
    var value2 = value1.replace(/^\D*(\d{1,8}(?:\.\d{0,2})?).*$/g, '$1')
    e.target.value = value2
    return value2
  },
  validateFields_money_limit_7_2 (e) { // 文本框输入金额限制 小数点前八后二
    var value1 = e.target.value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
    var value2 = value1.replace(/^\D*(\d{1,7}(?:\.\d{0,2})?).*$/g, '$1')
    e.target.value = value2
    return value2
  },
  validateFields_fumoney_limit (e) { // 文本框输入金额限制 小数点前八后二 含负号
    var value1 = e.target.value.replace(/^((-)?\d*(?:\.\d{0,2})?).*$/g, '$1')
    var value2 = value1.replace(/^((-)?\d{1,8}(?:\.\d{0,2})?).*$/g, '$1')
    e.target.value = value2
    return value2
  },
  validateFields_money_limit_3_2 (e) { // 文本框输入金额限制 小数点前八后二
    var value1 = e.target.value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
    var value2 = value1.replace(/^\D*(\d{1,3}(?:\.\d{0,2})?).*$/g, '$1')
    e.target.value = value2
    return value2
  },
  validateFields_money_limit_8_3 (e) { // 文本框输入金额限制 小数点前八后三
    var value1 = e.target.value.replace(/^\D*(\d*(?:\.\d{0,3})?).*$/g, '$1')
    var value2 = value1.replace(/^\D*(\d{1,8}(?:\.\d{0,3})?).*$/g, '$1')
    e.target.value = value2
    return value2
  },
  validateFields_money_limit_8_4 (e) { // 文本框输入金额限制 小数点前八后四
    var value1 = e.target.value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')
    var value2 = value1.replace(/^\D*(\d{1,8}(?:\.\d{0,4})?).*$/g, '$1')
    e.target.value = value2
    return value2
  },
  validateFields_money_limit_5_3 (e) { // 文本框输入金额限制 小数点前八后三
    var value1 = e.target.value.replace(/^\D*(\d*(?:\.\d{0,3})?).*$/g, '$1')
    var value2 = value1.replace(/^\D*(\d{1,5}(?:\.\d{0,3})?).*$/g, '$1')
    e.target.value = value2
    return value2
  },
  money_limit_8_1 (param) { // 文本框输入金额限制 小数点前八后一
    if (param == null || param == '') {
      return ''
    }
    var param1 = param.replace(/^\D*(\d*(?:\.\d{0,1})?).*$/g, '$1')
    var param2 = param1.replace(/^\D*(\d{1,8}(?:\.\d{0,1})?).*$/g, '$1')
    return param2
  },
  money_limit_8_2 (param) { // 文本框输入金额限制 小数点前八后二
    if (param == null || param == '') {
      return ''
    }
    var param1 = param.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
    var param2 = param1.replace(/^\D*(\d{1,8}(?:\.\d{0,2})?).*$/g, '$1')
    return param2
  },
  money_limit_8_3 (param) { // 文本框输入金额限制 小数点前八后三
    if (param == null || param == '') {
      return ''
    }
    var param1 = param.replace(/^\D*(\d*(?:\.\d{0,3})?).*$/g, '$1')
    var param2 = param1.replace(/^\D*(\d{1,8}(?:\.\d{0,3})?).*$/g, '$1')
    return param2
  },
  money_limit_8_4 (param) { // 文本框输入金额限制 小数点前八后三
    if (param == null || param == '') {
      return ''
    }
    var param1 = param.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')
    var param2 = param1.replace(/^\D*(\d{1,8}(?:\.\d{0,4})?).*$/g, '$1')
    return param2
  },
  validateFields_code (e, length) {
    var value = e.target.value.replace(/[^a-zA-Z0-9]/gi, '')
    if (value.length > length) {
      value = value.substring(0, length)
    }
    e.target.value = value
    return value
  },
  validateFields_num (e) { // 文本框输入整数
    var value = e.target.value.replace(/^\D*(\d*(?:)?).*$/g, '$1')
    e.target.value = value
    return value
  },
  validateFields_num_param (param) {
    if (param == null || param == '') {
      return ''
    }
    var value = param.replace(/^\D*(\d*(?:)?).*$/g, '$1')
    return value
  },
  validateFields_money_matchlength (e, len) {
    var value = e.target.value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
    if (value.indexOf('.') != -1) {
      var strs = value.split('.')
      var numStr = strs[0]
      if (numStr.length > len) {
        numStr = numStr.substring(0, len)
      }
      value = numStr + '.' + strs[1]
    } else if (value.length > len) {
      value = value.substring(0, len)
    }
    e.target.value = value
    return value
  },
  validateFields_num_matchlength_fixed1 (e, len) {
    var value = e.target.value.replace(/^\D*(\d*(?:\.\d{0,1})?).*$/g, '$1')
    if (value.indexOf('.') != -1) {
      var strs = value.split('.')
      var numStr = strs[0]
      if (numStr.length > len) {
        numStr = numStr.substring(0, len)
      }
      value = numStr + '.' + strs[1]
    } else if (value.length > len) {
      value = value.substring(0, len)
    }
    e.target.value = value
    return value
  },
  validateFields_input_str (e) {
    // 只允许输入字母数字汉字和指定的特殊字符
    var value = e.target.value.replace(/[^a-zA-Z\d\u4e00-\u9fa5，。!？()]/g, '')
    e.target.value = value
    return value
  },
  mergeArray (arr1, arr2, key) {
    arr2.map(item => {
      var data = arr1.find(d => d[key] === item[key])
      if (!data) {
        arr1.push(item)
      }
    })
    return arr1
  },
  // 获取启用和本身数据
  // 必传参数
  // ----myDataId：保留的数据id
  // ----myState：保留的数据状态
  // ----myDataList：数据集合
  // ----myIdName：数据主键字段名(例如：主键是id，传'id')；
  // ----myStateName：数据启用/禁用字段名(例如：启用/禁用是state，传'state')；
  fnGetEnableDataAndMySelf (myDataId, myState, myDataList, myIdName, myStateName) {
    if (!myDataId || myDataList == null || myDataList.length == 0 || myState == null || !myIdName || !myStateName) {
      console.log('_________不能为空myDataId=' + myDataId)
      console.log('_________不能为空myState=' + myState)
      console.log('_________不能为空myDataList=' + myDataList)
      console.log('_________不能为空myIdName=' + myIdName)
      console.log('_________不能为空myStateName=' + myStateName)
      console.log('_________部分参数为空')
      return myDataList
    }
    var list = []
    myDataList.forEach((item, index) => {
      let idValue = item.id
      if (myIdName) {
        idValue = item[myIdName]
      }
      let stateValue = item.state
      if (myStateName) {
        stateValue = item[myStateName]
      }
      if (idValue == myDataId || stateValue == myState) {
        list.push(item)
      }
    })
    return list
  },
  // 获取启用和本身数据
  // 必传参数
  // ----myDataIds：保留的数据id
  // ----myState：保留的数据状态
  // ----myDataList：数据集合
  // ----myIdName：数据主键字段名(例如：主键是id，传'id')；
  // ----myStateName：数据启用/禁用字段名(例如：启用/禁用是state，传'state')；
  fnGetEnableDataAndMySelfs (myDataIds, myState, myDataList, myIdName, myStateName) {
    if (!myDataIds || myDataList == null || myDataList.length == 0 || myState == null || !myIdName || !myStateName) {
      console.log('_________不能为空myDataId=' + myDataIds)
      console.log('_________不能为空myState=' + myState)
      console.log('_________不能为空myDataList=' + myDataList)
      console.log('_________不能为空myIdName=' + myIdName)
      console.log('_________不能为空myStateName=' + myStateName)
      console.log('_________部分参数为空')
      return myDataList
    }
    var list = []
    myDataList.forEach((item, index) => {
      let idValue = item.id
      if (myIdName) {
        idValue = item[myIdName]
      }
      let stateValue = item.state
      if (myStateName) {
        stateValue = item[myStateName]
      }
      if (stateValue == myState) {
        list.push(item)
      } else {
        for (var i = 0; i < myDataIds.length; i++) {
          if (idValue == myDataIds[i]) {
            list.push(item)
            break
          }
        }
      }
    })
    return list
  },
  /* pmProjectInfoBo 返现的数据
  * myDataList 下拉集合
  * myIdName 下拉数据value
  * myIdNameText 下拉数据值
  * createId  返现的数据id
  * createName  返现的数据name
  */
  fnGetEnableDataEditPushMySelf (myDataIds, myDataList, myIdName, myIdNameText, addObj) {
    var list = myDataList
    var flg = false
    myDataList.forEach((item, index) => {
      let idValue = item.id
      if (myIdName) {
        idValue = item[myIdName]
      }
      if (idValue == myDataIds) {
        flg = true
      }
    })
    if (!flg) {
      var param = addObj
      list.push(param)
    }
    return list
  },
  // 成员权限 obj:返回的单条数据, 获取的权限
  memberRuleShow: function (obj, ruleStr) {
    if (obj == null || obj == '' || obj.teamMembersRule == null || obj.teamMembersRule == '') {
      return false
    }
    if (ruleStr == 'editProject') { // 修改项目
      return obj.teamMembersRule.editProject
    } else if (ruleStr == 'setBuget') { // 指定预算
      return obj.teamMembersRule.setBuget
    } else if (ruleStr == 'setAssign') { // 任务指派
      return obj.teamMembersRule.setAssign
    } else if (ruleStr == 'doProcess') { // 执行任务
      return obj.teamMembersRule.doProcess
    } else if (ruleStr == 'selBuget') { // 查看预算
      return obj.teamMembersRule.selBuget
    } else if (ruleStr == 'costApply') { // 发起借款
      return obj.teamMembersRule.costApply
    } else if (ruleStr == 'costReimburse') { // 直接报销
      return obj.teamMembersRule.costReimburse
    } else if (ruleStr == 'selExpense') { // 查看花销
      return obj.teamMembersRule.selExpense
    } else if (ruleStr == 'setContract') { // 合同录入
      return obj.teamMembersRule.setContract
    } else if (ruleStr == 'selContract') { // 查看合同
      return obj.teamMembersRule.selContract
    } else if (ruleStr == 'stopProject') { // 项目终止
      return obj.teamMembersRule.stopProject
    } else if (ruleStr == 'endProject') { // 项目结项
      return obj.teamMembersRule.endProject
    } else if (ruleStr == 'purchaseApply') { // 采购申请
      return obj.teamMembersRule.purchaseApply
    } else {
      return false
    }
  },
  formatDateYYYYMMDD (date) {
    if (!date) {
      return '--'
    } else {
      return moment(date).format('YYYY-MM-DD')
    }
  },
  // 单选下拉，搜索回调
  filterOption (input, option) {
    return (
      option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    )
  },
  // 解决layer弹出层，下拉 与下拉内容分离的bug
  getContainer () {
    return triggerNode => triggerNode.parentNode || document.body
  },
  beforeMount (height) {
    var h = document.documentElement.clientHeight || document.body.clientHeight
    return h - height // 减去页面上固定高度height
  },
  fnFinishPointFormat (value) { // 完成情况百分比格式化保留1位小数且省略小数点后的0
    var returnValue = parseFloat(value).toFixed(1) * 100 / 100
    return returnValue + '%'
  },
  /**
   * @param {Object} thiss this
   * @param {Object} titleName 操作:作废启用禁用删除等
   * @param {Object} okMethod 确认方法
   * @param {Object} cancelMethod 取消方法
   */
  toolConfirm (thiss, titleName, ok, cancel) {
    if (titleName == null || titleName == '') {
      titleName = '本次'
    }
    var height = this.beforeMount(0)
    height = (height / 2) - 80
    // commonTool.stopMove()
    thiss.$confirm({
      title: '提示',
      content: '确定要执行' + titleName + '操作吗 ?',
      style: 'margin-top:' + height + 'px;top:0px',
      onOk: () => {
        // commonTool.move()
        if (ok != null) {
          ok.call(thiss)
        }
      },
      onCancel () {
        // commonTool.move()
        if (cancel != null) {
          cancel.call(thiss)
        }
      }
    })
  },
  /**
   * @param {Object} thiss this
   * @param {Object} titleName 操作:作废启用禁用删除等
   * @param {Object} okMethod 确认方法
   * @param {Object} cancelMethod 取消方法
   */
  toolConfirmText (thiss, titleName, ok, cancel, okText, cancelText) {
    if (titleName == null || titleName == '') {
      titleName = '确定要执行本次操作吗 ?'
    }
    if (!okText) {
      okText = '确认'
    }
    if (!cancelText) {
      cancelText = '取消'
    }
    var height = this.beforeMount(0)
    height = (height / 2) - 80
    commonTool.stopMove()
    thiss.$confirm({
      title: '提示',
      content: titleName,
      okText: okText,
      cancelText: cancelText,
      style: 'margin-top:' + height + 'px;top:0px',
      onOk: () => {
        commonTool.move()
        if (ok != null) {
          ok.call(thiss)
        }
      },
      onCancel () {
        commonTool.move()
        if (cancel != null) {
          cancel.call(thiss)
        }
      }
    })
  },
  // 隔行换色
  interlacingRowStyle (record, index) {
    // 判断奇偶数 为0时偶数
    return ''
    // if (index % 2 == 0) {
    //   return 'interlacingRowStyle'
    // }
  },
  // 项目等级转换
  projectLevelFormat (offerAmount, dictSourceItems) {
    if (offerAmount == null) {
      return '--'
    }
    if (offerAmount == 0) {
      return dictSourceItems[0].label
    } else {
      var dicItemValue = '--'
      dictSourceItems.forEach(item => {
        if (offerAmount > item.extendFieldA && offerAmount <= item.extendFieldB) {
          dicItemValue = item.label
        }
      })
      return dicItemValue
    }
  },
  generateUUID () {
    var d = new Date().getTime()
    if (window.performance && typeof window.performance.now === 'function') {
      d += performance.now()
    }
    var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
    return uuid
  },
  generateDictCode () {
    // 生成字典编号
    return 'KSCJ' + moment().format('YYYYMMDDhhmmss')
  },
  columnsScopedSlots (customRenderStr, filterDropdownStr, filterIconStr) {
    return { customRender: customRenderStr, filterDropdown: filterDropdownStr, filterIcon: filterIconStr }
  },
  // 打开弹出层公共方法
  layerOpen (obj, thiss, refresTable) {
    window.screenWidth = document.body.offsetWidth
    // alert(window.screenWidth)
    commonTool.stopMove()
    obj.type = 2
    obj.maxmin = false
    if (obj.area != null && obj.area != '') {
    } else {
      obj.area = ['calc(100% - 256px)', 'calc(100% - 115px)']
    }
    obj.fixed = false
    obj.shade = true
    obj.shadeClose = false
    // if (window.screenWidth <= 1400) {
    //   obj.offset = ['812', '380']
    // } else {
    //   obj.offset = ['1088', '530']
    // }
    obj.resize = true
    if (typeof obj.cancel != 'function') {
      obj.cancel = function () {
        if (thiss) {
          commonTool.closeSinglePageRight(thiss, refresTable)
        }
        if (obj.stopMove) { // 弹出层打开弹出层继续隐藏滚动
          commonTool.stopMove()
        } else {
          commonTool.move()
        }
      }
    }
    const ret = thiss.$layer.open(obj)
    // thiss.$layer.full(ret)
    return ret
  },
  getFileType (fixName) {
    if (fixName.toLowerCase() == 'png' || fixName.toLowerCase() == 'jpg' || fixName.toLowerCase() == 'jpeg' || fixName.toLowerCase() == 'bmp') {
      return '00001'
    } if (fixName.toLowerCase() == 'cdr') {
      return '00002'
    } else if (fixName.toLowerCase() == 'psd') {
      return '00003'
    } else if (fixName.toLowerCase() == 'ai') {
      return '00004'
    } else if (fixName.toLowerCase() == 'doc' || fixName.toLowerCase() == 'docx' || fixName.toLowerCase() == 'xls' || fixName.toLowerCase() == 'xlsx' || fixName.toLowerCase() == 'ppt'  || fixName.toLowerCase() == 'pptx') {
      return '00005'
    }else if (fixName.toLowerCase() == 'dwt' || fixName.toLowerCase() == 'dwg' || fixName.toLowerCase() == 'dws' || fixName.toLowerCase() == 'dxf') {
      return '00006'
    } else {
      return '99999'
    }
  },
  //附件类型图标
  getFileTypeLogo(file){
    if (file.fileType =='00001') {
      return require('../assets/center/images/gr_13.png')
    } else if (file.fileType =='00002') {
      return require('../assets/center/images/gr_11.png')
    } else if (file.fileType() =='00003') {
      return require('../assets/center/images/gr_15.png')
    } else if (file.fileType() =='00004') {
      return require('../assets/center/images/gr_17.png')
    } else if (file.fileType() =='00005') {
      return require('../assets/center/images/gr_13.png')
    }else if (file.fileType() =='00006') {
      return require('../assets/center/images/gr_13.png')
    } else {
      return require('../assets/center/images/gr_13.png')
    }
  }
}

const numberTool = {
  // 保留小数位数，返回字符串,str 数值 precision位数
  myRoundStr: function (srcStr, nAfterDot) {
    let resultStr, nTen
    srcStr = '' + srcStr + ''
    const strLen = srcStr.length
    const dotPos = srcStr.indexOf('.', 0)
    if (dotPos == -1) {
      resultStr = srcStr + '.'
      for (let i = 0; i < nAfterDot; i++) {
        resultStr = resultStr + '0'
      }
      return resultStr
    } else {
      if ((strLen - dotPos - 1) >= nAfterDot) {
        nTen = 1
        for (let j = 0; j < nAfterDot; j++) {
          nTen = nTen * 10
        }
        resultStr = Math.round(parseFloat(srcStr) * nTen) / nTen
        return resultStr
      } else {
        resultStr = srcStr
        for (let i = 0; i < (nAfterDot - strLen + dotPos + 1); i++) {
          resultStr = resultStr + '0'
        }
        return resultStr
      }
    }
  },
  // 保留小数位数，返回字符串,str 数值 precision位数，同时去除多余的0
  myRoundStrRmZero: function (srcStr, nAfterDot) {
    return parseFloat(this.myRoundStr(srcStr, nAfterDot))
  },
  // 截取小数后几位,返回小数
  getDecimalNum (decimalStr, decimalPlaces) {
    if (decimalStr == null || decimalStr == '') {
      return ''
    }
    if (!decimalPlaces) {
      decimalPlaces = 2
    } else {
      decimalPlaces = decimalPlaces + 1
    }
    var pointIndex = decimalStr.toString().indexOf('.')
    if (pointIndex != '-1') {
      // proportion = proportion.toString().substring(0, parseInt(pointIndex) + 2)
      decimalStr = decimalStr.toString().substring(0, parseInt(pointIndex) + decimalPlaces)
    } else {
      decimalStr = decimalStr.toFixed(decimalPlaces)
    }
    return decimalStr
  },
  // 分转元
  branchSwitch: function (srcStr, nAfterDot) {
    if (srcStr == null || isNaN(srcStr)) {
      return '0.00'
    }
    let resultStr, nTen
    // srcStr = srcStr / 100
    srcStr = numberTool.numDiv(srcStr, 100)
    srcStr = '' + srcStr + ''
    const strLen = srcStr.length
    const dotPos = srcStr.indexOf('.', 0)
    if (dotPos == -1) {
      resultStr = srcStr + '.'
      for (let i = 0; i < nAfterDot; i++) {
        resultStr = resultStr + '0'
      }
      return resultStr
    } else {
      if ((strLen - dotPos - 1) >= nAfterDot) {
        nTen = 1
        for (let j = 0; j < nAfterDot; j++) {
          // nTen = nTen * 10
          nTen = numberTool.numMulti(nTen, 10)
        }
        // resultStr = Math.round(parseFloat(srcStr) * nTen) / nTen
        resultStr = numberTool.numDiv(Math.round(numberTool.numMulti(srcStr, nTen)), nTen)
        return toolRex.toDecimal(resultStr, nAfterDot)
      } else {
        resultStr = srcStr
        for (let i = 0; i < (nAfterDot - strLen + dotPos + 1); i++) {
          resultStr = resultStr + '0'
        }
        return resultStr
      }
    }
  },
  // 厘转元
  branchSwitchLi: function (srcStr, nAfterDot) {
    if (srcStr == null || isNaN(srcStr)) {
      return '0.000'
    }
    let resultStr, nTen
    srcStr = srcStr / 1000
    srcStr = '' + srcStr + ''
    const strLen = srcStr.length
    const dotPos = srcStr.indexOf('.', 0)
    if (dotPos == -1) {
      resultStr = srcStr + '.'
      for (let i = 0; i < nAfterDot; i++) {
        resultStr = resultStr + '0'
      }
      return resultStr
    } else {
      if ((strLen - dotPos - 1) >= nAfterDot) {
        nTen = 1
        for (let j = 0; j < nAfterDot; j++) {
          nTen = nTen * 10
        }
        resultStr = Math.round(parseFloat(srcStr) * nTen) / nTen
        return resultStr
      } else {
        resultStr = srcStr
        for (let i = 0; i < (nAfterDot - strLen + dotPos + 1); i++) {
          resultStr = resultStr + '0'
        }
        return resultStr
      }
    }
  },
  // 分转千位运算符：srcStr金额  nAfterDot保留几位小数
  toThousands: function (srcStr, nAfterDot) {
    var result, couNum, xsbfStr, zsbfStr
    // 分转元并且保留对应位数小数 之后的 金额字符串
    const resultStr = this.branchSwitch(srcStr, nAfterDot) + ''
    const resultArr = resultStr.split('.')
    result = ''
    couNum = 0
    xsbfStr = resultArr[1]// 小数部分的金额
    zsbfStr = resultArr[0]// 整数部分的金额
    for (var i = zsbfStr.length - 1; i >= 0; i--) {
      couNum++
      result = zsbfStr.charAt(i) + result
      if (!(couNum % 3) && i != 0) {
        result = ',' + result
      }
    }
    result = result + '.' + xsbfStr
    return result
  },
  // 元转分
  branchYuanToFen: function (x) {
    if (x == null || x == undefined || isNaN(x)) {
      return '0.00'
    }
    var f = parseFloat(x)
    if (isNaN(f)) {
      return '0.00'
    }
    f = Math.round(x * 100) / 100
    var s = f.toString()
    var rs = s.indexOf('.')
    if (rs < 0) {
      rs = s.length
      s += '.'
    }
    while (s.length <= rs + 2) {
      s += '0'
    }
    return parseInt((parseFloat(s) * 100).toFixed(2))
  },
  // 元转厘
  branchYuanToLi: function (x) {
    if (x == null || x == undefined || isNaN(x)) {
      return '0.000'
    }
    var f = parseFloat(x)
    if (isNaN(f)) {
      return '0.000'
    }
    f = Math.round(x * 1000) / 1000
    var s = f.toString()
    var rs = s.indexOf('.')
    if (rs < 0) {
      rs = s.length
      s += '.'
    }
    while (s.length <= rs + 3) {
      s += '0'
    }
    return parseInt((parseFloat(s) * 1000).toFixed(3))
  },
  formatMoneyFixed2: function (money, str) {
    // 格式化金额并保留两位小数  如果金额位空 则返回str
    if (!money && !isNaN(money)) {
      return str
    } else {
      return parseFloat(money).toFixed(2)
    }
  },
  formatMoneyFixed4: function (money, str) {
    // 格式化金额并保留两位小数  如果金额位空 则返回str
    if (!money && !isNaN(money)) {
      return str
    } else {
      return parseFloat(money).toFixed(4)
    }
  },
  // 四舍五入保留n位
  formatNumberFixed2: function (num, n) {
    var index = 1
    for (var i = 0; i < n; i++) {
      index = index * 10
    }
    return (Math.round(num * index) / index).toFixed(2)
  },
  // 去掉小数保留整数
  numInteger (num) {
    return parseInt(num)
  },
  // .向上取整,有小数就整数部分加1
  numUpWardInteger (num) {
    return Math.ceil(num)
  },
  // 四舍五入
  numRoundedInteger (num) {
    return Math.round(num)
  },
  // .向下取整,有小数就整数部分加1
  numDownWardInteger (num) {
    return Math.floor(num)
  },
  //  加法运算，避免数据相加小数点后产生多位数和计算精度损失
  //  @param num1加数1 | num2加数
  numAdd (num1, num2) {
    var baseNum, baseNum1, baseNum2
    try {
      baseNum1 = num1.toString().split('.')[1].length
    } catch (e) {
      baseNum1 = 0
    }
    try {
      baseNum2 = num2.toString().split('.')[1].length
    } catch (e) {
      baseNum2 = 0
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2))
    return (num1 * baseNum + num2 * baseNum) / baseNum
  },
  // 减法运算，避免数据相减小数点后产生多位数和计算精度损失
  // @param num1被减数 | num2减数  precision 精度
  numSub (num1, num2, precision) {
    var baseNum, baseNum1, baseNum2
    try {
      baseNum1 = num1.toString().split('.')[1].length
    } catch (e) {
      baseNum1 = 0
    }
    try {
      baseNum2 = num2.toString().split('.')[1].length
    } catch (e) {
      baseNum2 = 0
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2))
    if (precision == null || precision == '') {
      precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2
    }
    return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision)
  },
  // 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失
  // @param num1被乘数 | num2乘数
  numMulti (num1, num2) {
    var baseNum = 0
    try {
      baseNum += num1.toString().split('.')[1].length
    } catch (e) {}
    try {
      baseNum += num2.toString().split('.')[1].length
    } catch (e) {}
    return Number(num1.toString().replace('.', '')) * Number(num2.toString().replace('.', '')) / Math.pow(10, baseNum)
  },
  // 除法运算，避免数据相除小数点后产生多位数和计算精度损失
  // @param num1被除数 | num2除数
  numDiv (num1, num2) {
    var baseNum1 = 0
    var baseNum2 = 0
    var baseNum3, baseNum4
    try {
      baseNum1 = num1.toString().split('.')[1].length
    } catch (e) {
      baseNum1 = 0
    }
    try {
      baseNum2 = num2.toString().split('.')[1].length
    } catch (e) {
      baseNum2 = 0
    }
    // with (Math) {
    baseNum3 = Number(num1.toString().replace('.', ''))
    baseNum4 = Number(num2.toString().replace('.', ''))
    return (baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1)
    // }
  },
  // 金额大写转换
  digitUppercase (n) {
    var fraction = ['角', '分']
    var digit = [ '零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖' ]
    var unit = [ ['元', '万', '亿'], ['', '拾', '佰', '仟'] ]
    var head = n < 0 ? '欠' : ''
    n = Math.abs(n)
    var s = ''
    for (var ii = 0; ii < fraction.length; ii++) {
      s += (digit[Math.floor(n * 10 * Math.pow(10, ii)) % 10] + fraction[ii]).replace(/零./, '')
    }
    s = s || '整'
    n = Math.floor(n)
    for (var i = 0; i < unit[0].length && n > 0; i++) {
      var p = ''
      for (var j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p
        n = Math.floor(n / 10)
      }
      s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
    }
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
  }
}

const toolsColors = {
  color_666666: function () {
    return 'color: #666666;webkit-text-fill-color: #666666;'
  }
}

export { toolRex, msgTool, commonTool, numberTool, toolsColors }



// WEBPACK FOOTER //
// ./src/util/tool.js